import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { useDebounce } from '@fuse/hooks';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { FaBuilding } from 'react-icons/fa';

const EmpresaSearchHeader = ({ fetchEmpresas, initialPage }) => {
  const empresaSearchStyles = makeStyles({
    searchHeaderVendas: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      maxWidth: '512px'
    },
  });

const styles = empresaSearchStyles();

  const pesquisar = useDebounce(
    (value) => {
      initialPage.query = value;
      fetchEmpresas(initialPage);
    },
    500,
    {}
  );

  return (
      <>
        <PageHeader title="Empresas" icon={<FaBuilding/>}>
          <div className={styles.empresaSearchStyles}>
            <SearchBar onChange={pesquisar} placeholder="Pesquisar" />
          </div>
        </PageHeader>
      </>
  );
};

export default EmpresaSearchHeader;
